import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import PreviewBanner from "./PreviewBanner";
import api from "@/lib/api";
import { X } from "lucide-react";

export default function Layout() {
    const [certPct, setCertPct] = useState(0);
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        let mounted = true;
        api.get("/progress/summary").then(({ data }) => {
            if (mounted) setCertPct(data?.certification_pct ?? 0);
        }).catch(() => {});
        return () => { mounted = false; };
    }, [location.pathname]);

    return (
        <div className="min-h-screen flex bg-ink-50" data-testid="app-layout">
            <Sidebar />

            {mobileOpen && (
                <div className="fixed inset-0 z-40 lg:hidden">
                    <div className="absolute inset-0 bg-ink-900/40" onClick={() => setMobileOpen(false)} />
                    <div className="absolute left-0 top-0 bottom-0 w-72 bg-ink-100 shadow-xl">
                        <button
                            onClick={() => setMobileOpen(false)}
                            className="absolute right-3 top-3 p-2 z-10 text-ink-700"
                            data-testid="mobile-nav-close"
                            aria-label="Close menu"
                        >
                            <X size={18} />
                        </button>
                        <div className="lg:hidden block">
                            <Sidebar onNavigate={() => setMobileOpen(false)} />
                        </div>
                    </div>
                </div>
            )}

            <main className="flex-1 min-w-0">
                <TopBar certPct={certPct} onOpenMobileNav={() => setMobileOpen(true)} />
                <PreviewBanner />
                <div className="px-4 sm:px-6 md:px-10 lg:px-12 py-8 md:py-12 max-w-[1400px] mx-auto animate-fade-in">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
